import type { RecurringRevenueReport } from '@vy/types';
import { applyReportSearch } from '../../reports-components/apply-report-search';

export function applyRecurringRevenueSearch(
  rows: RecurringRevenueReport,
  searchText?: string,
): RecurringRevenueReport {
  return applyReportSearch(rows, searchText, ({ customerName, parentName, contractName }) => [
    customerName,
    parentName,
    contractName,
  ]);
}
